import { apiCall } from "utils/apiClient";

const getStepSortValue = (item, fallbackIndex = 0) => {
  const stepOrder = Number(item?.step_order);

  if (Number.isFinite(stepOrder) && stepOrder > 0) {
    return stepOrder;
  }

  return fallbackIndex + 1;
};

export const getServiceProcessStepsByService = async (serviceId) =>
  apiCall({
    endpoint: `service-process-steps/service/${serviceId}`,
    method: "GET",
  });

export const createServiceProcessStep = async (payload) =>
  apiCall({
    endpoint: "service-process-steps/create",
    method: "POST",
    data: payload,
  });

export const updateServiceProcessStep = async (id, payload) =>
  apiCall({
    endpoint: `service-process-steps/update/${id}`,
    method: "PUT",
    data: payload,
  });

export const deleteServiceProcessStep = async (id) =>
  apiCall({
    endpoint: `service-process-steps/delete/${id}`,
    method: "DELETE",
  });

export const uploadServiceProcessStepIcon = async (file) => {
  const formData = new FormData();
  formData.append("icon", file);

  return apiCall({
    endpoint: "service-process-steps/icon/upload",
    method: "POST",
    data: formData,
  });
};

export const deleteServiceProcessStepIcon = async (iconPath) =>
  apiCall({
    endpoint: "service-process-steps/icon",
    method: "DELETE",
    data: {
      icon: iconPath,
    },
  });

export const createMultipleServiceProcessSteps = async (
  serviceId,
  steps = [],
  startStepNumber = 0
) => {
  const responses = [];

  for (let index = 0; index < steps.length; index += 1) {
    const step = steps[index];
    const stepNumber = startStepNumber + index + 1;

    const response = await createServiceProcessStep({
      service_id: serviceId,
      step_title: step?.step_title?.trim(),
      step_description: step?.step_description?.trim(),
      step_order: stepNumber,
      estimated_time: step?.estimated_time?.trim() || "",
      icon: step?.icon?.trim() || "",
      status: step?.status || "active",
    });

    responses.push(response);

    if (response?.status !== 200 && response?.status !== 201) {
      return {
        status: response?.status || 500,
        message: response?.message || `Failed to save step ${index + 1}`,
        data: {
          failedStep: index + 1,
          responses,
        },
      };
    }
  }

  return {
    status: 201,
    message: "Service process steps added successfully",
    data: responses,
  };
};

export const updateMultipleServiceProcessSteps = async (serviceId, steps = []) => {
  const responses = [];

  for (let index = 0; index < steps.length; index += 1) {
    const step = steps[index];
    const stepId = step?.id;
    const stepOrder = index + 1;

    if (!stepId) {
      return {
        status: 400,
        message: `Saved step ${stepOrder} is missing id`,
        data: {
          failedStep: stepOrder,
          responses,
        },
      };
    }

    const response = await updateServiceProcessStep(stepId, {
      service_id: serviceId,
      step_title: step?.step_title?.trim(),
      step_description: step?.step_description?.trim(),
      step_order: stepOrder,
      estimated_time: step?.estimated_time?.trim() || "",
      icon: step?.icon?.trim() || "",
      status: step?.status || "active",
    });

    responses.push(response);

    if (response?.status !== 200 && response?.status !== 201) {
      return {
        status: response?.status || 500,
        message: response?.message || `Failed to update step ${stepOrder}`,
        data: {
          failedStep: stepOrder,
          responses,
        },
      };
    }
  }

  return {
    status: 200,
    message: "Service process steps updated successfully",
    data: responses,
  };
};

export const sortServiceProcessSteps = (steps = []) =>
  steps.slice().sort((a, b) => {
    const stepA = getStepSortValue(a);
    const stepB = getStepSortValue(b);

    if (stepA !== stepB) {
      return stepA - stepB;
    }

    return String(a?.step_title || "").localeCompare(String(b?.step_title || ""));
  });

export { getStepSortValue };
